import React from 'react';
import { FDBodyText, FDHeadlineText, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { useDataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder, getBorderRadius } from 'Components/utils';

const useStyles = buildUseStyles('TermsAndConditionsScroller', (theme) => ({
  // Can't use FDPaper, because it doesn't support subtle+outlined. This design breaks our rules though
  box: {
    ...getBorder(theme, { all: true, color: theme.palette.facet.stone600 }),
    ...getBorderRadius(theme.radius.md, { all: true }),
    padding: theme.spacing(2),
  },
}));

export const AgreementDetails = ({
  label, value, richtext, ...rest
}) => {
  const classes = useStyles();
  const dataAttrs = useDataAttrs(rest);
  return (
    <FDStack spacing={2} direction={'column'}>
      <FDHeadlineText value={label} color="textSecondary" />
      <div className={classes.box}>
        <Richtext {...dataAttrs} value={value} richtext={richtext} Component={FDBodyText} size="sm" />
      </div>
    </FDStack>
  );
};

AgreementDetails.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  richtext: PropTypes.bool.isRequired,
};
